import { lazy } from "react";
import { useLocation } from "react-router-dom";
import type { AppRoute } from "../../routes";
import { spaAssetBase, type PageData } from "../../api";
import { AccountActivityPage } from "../users/AccountActivity";

const MapViewPage = lazy(() => import("../../pages/inventory/MapViewPage").then((m) => ({ default: m.MapViewPage })));
const InventorySitePage = lazy(() =>
  import("../../pages/inventory/InventorySitePage").then((m) => ({ default: m.InventorySitePage }))
);
const InventoryConfigPage = lazy(() =>
  import("../../pages/inventory/InventoryConfigPage").then((m) => ({ default: m.InventoryConfigPage }))
);
const MapConfigPage = lazy(() => import("../../pages/inventory/MapConfigPage").then((m) => ({ default: m.MapConfigPage })));
const AnalyticsPage = lazy(() => import("../../pages/analytics").then((m) => ({ default: m.AnalyticsPage })));
const AnalyticsConfigPage = lazy(() =>
  import("../../pages/analyticsConfig").then((m) => ({ default: m.AnalyticsConfigPage }))
);
const ConnectorPage = lazy(() => import("../../pages/connector").then((m) => ({ default: m.ConnectorPage })));
const TaskStatusPage = lazy(() =>
  import("../../pages/inventory/TaskStatusPage").then((m) => ({ default: m.TaskStatusPage }))
);

function emptyPage(route: AppRoute): PageData {
  return {
    route: route.id,
    title: route.title,
    description: route.description,
    datasets: [],
    actions: [],
    meta: {},
  };
}

export function LegacyParityPage({ route }: { route: AppRoute }) {
  const location = useLocation();
  const page = emptyPage(route);
  if (route.id === "account_activity" || location.pathname === "/user-activity") {
    return <AccountActivityPage route={route} page={page} />;
  }
  if (route.id === "map_view" || location.pathname === "/map") return <MapViewPage route={route} page={page} />;
  if (route.id === "inventory_site" || location.pathname === "/inventory/site") return <InventorySitePage route={route} page={page} />;
  if (route.id === "inventory_config" || location.pathname === "/inventory/config") return <InventoryConfigPage route={route} page={page} />;
  if (route.id === "map_config" || location.pathname === "/map-config") return <MapConfigPage route={route} page={page} />;
  if (route.id === "analytics" || location.pathname === "/analytics") return <AnalyticsPage route={route} page={page} />;
  if (route.id === "analytics_config" || location.pathname === "/analytics-config")
    return <AnalyticsConfigPage route={route} page={page} />;
  if (route.id === "connector" || location.pathname === "/connector") return <ConnectorPage route={route} page={page} />;
  if (route.id === "task_status" || location.pathname === "/task-status") return <TaskStatusPage route={route} page={page} />;
  const frameUrl = `${spaAssetBase()}${location.pathname}${location.search}`;
  return (
    <div className="legacy-parity-page">
      <iframe
        title={`${route.title} legacy functional page`}
        src={frameUrl}
        className="legacy-parity-frame"
      />
    </div>
  );
}
